import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from "src/app/core/services/requests.service";
import * as XLSX from 'xlsx';

/* const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'; */
@Injectable({
  providedIn: 'root'
})
export class CargueService {
  //ENDPOINT = "http://127.0.0.1:8000/api/v1/cargue_archivo_tabla_PPTO_ARCHIVO";
  requestsService: any;
  ENDPOINT = getEndpoint('cargue_masivo_presupuesto');
  
  constructor(private _http: HttpClient, private _http2: RequestsService) { }

  transformEtiquetasToInsert(etiquetas: CargueP[]) {
    return etiquetas ? etiquetas.map((value, index) => {
      value["c_emp"] = getConnection();
      return value;
    }) : []
  }

  async cargue(company: string, payload: any): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/cargue_presu/${company}`;
    return await this._http2.postLikeJSON(url, payload);
  }

  async eliminarArchivo(company: string): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/eliminar/${company}`;
    return await this._http2.delete(url);
  }


  async procesarArchivo(company: string, periodo: any,inicio: any,fin: any): Promise<BasicResponse> {
    // Enviar los datos en un solo objeto JSON
    const body = {
      periodo: periodo,
      inicio: inicio,
      fin: fin
    };
    const url = `${this.ENDPOINT}/procesar_archivo/${company}`;
    return await this._http2.postLikeJSON(url,body);
  }

  /* async getArchivo(company: string, periodo): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/descargue/${company}/${periodo}`;
    const res: BasicResponse = await this._http.get<BasicResponse>(url).toPromise();
    return res
  } */

  /* public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  } */

  /* private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    var link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      var url = URL.createObjectURL(data);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName + EXCEL_EXTENSION);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } */
}

export class CargueP {
  PAIS: string;
  ALTERNATIVA: string;
  AGENCIA: string;
  CATEGORIA: string;
  LINEA: string;
  SUBLINEA: string;
  VENTA_OFERTA: string;
  CMV: string;
  ARMADO: string;
  FLETE: string;
  BODEGAJE: string;
  GARANTIA: string;
}